import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { VoucherDetails } from '../models/voucherDetails';

@Injectable({
    providedIn: 'root'
  })
  export class OfferService extends BaseService {
    apiUrl = '/api/couponz/';
    constructor(private httpClient: HttpClient) {
      super();
    }
    getAllOffers() {
      return this.httpClient.get<VoucherDetails[]>(
        this.baseUrl + this.apiUrl + 'GetAllOffers',
        this.getAuthHeader()
      );
    }
      
}